import { useContext, useEffect, useMemo, useState } from "react";
import { tokens } from "../Context/Tokens";
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { SinFactura, SinFacturaInicial } from "../Model/Tablas/SinFactura";
import { Get } from "../Rutas/ApiRest";
import { Carga, VendemosContigo } from "../Rutas/Servicios";
import { usePagination, useTable } from "react-table";
import SoloFacturas from "../Componentes/SoloFacturas";
import { PreAlertaVendemosContigo, PreAlertaVendemosContigoInicial } from "../Model/Tablas/PreAlertasVendemosContigoCon";
import SoloPreAlertaVendemosContigo from "../Componentes/SoloPreAlertaVendemosContigo";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";


export default function VendemosContigoCon()
{

    var count=0;
  const {tok}=useContext(tokens)
  const {Cli}=useContext(Contexto)
  const {SetMensajeEmergente,SetLoading,Id,Id2}=useContext(MensajeContActualizacion)

  const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
  const datos=[
    PreAlertaVendemosContigoInicial
    ]
    const columns=useMemo(() => PreAlertaVendemosContigo, [])
    const dato=useMemo(() => datos, [])
    const [data,Setdata]=useState(dato)    

   useEffect(()=>{
      ActualizarDatos();
   },[Cli.Eleccion])

   useEffect(()=>
    {
        if(Id==0)
        {
            ActualizarDatos()
        }
    },[Id])
    useEffect(()=>
    {
        ActualizarDatos()
    },[Id2])

   const ActualizarDatos=()=>
   {
      if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
      {
          if(Cli.lCasilla[Cli.Eleccion].ecode!="")
          {
              const historialcargas=Get(VendemosContigo.TraerGuiasCon.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@rut",Cli.rut).replace("@guiahija",GuiaBusqueda),"application/json",tok)
              historialcargas.then(resultado=>{Setdata(resultado)})
          }
      }

   }

        const {
          getTableProps, 
          getTableBodyProps, 
          headerGroups, 
          page,
          nextPage,
          previousPage,
          canNextPage,
          canPreviousPage,
          pageOptions,
          gotoPage,
          pageCount,
          state,
          prepareRow,
      } = useTable({
              // @ts-ignore
              columns,
              data,
          },
          usePagination
      );

      const { pageIndex } = state
  return (
      <>
      {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="One"> <span className="content" >No tiene PreAlertas a modificar.</span>

                  </div></div>:<div className="row">
          <div className="col-12 py-2 py-sm-0">
            <div className="table-responsive" >
            <div className="fondo-blanco h-100">
          {page.map((row: any) =>
          {
              count=count+1;
              prepareRow(row)
              return(
                  <div className="card-body">
                      <div className="accordion" id="accordionFlushTabla">
                      {row.cells.map((cell: any) =>
                      {
                          
                          return (
                              cell.column.Header==="preAlerta"?
                              <>
                               <SoloPreAlertaVendemosContigo guia={cell.value} id={count} contenido={row.cells}></SoloPreAlertaVendemosContigo>
                              </>:null
                          )
                      })}
                                 
                      </div>
                  </div>
              )
          })}
          

      </div>
            </div>
            </div>
        </div>

                  }

{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
<a href={"#Rastreo"}>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                      Anterior
                  </button>
                 
                 
              </a>
              
              <span>
                  <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                      {pageIndex + 1} / {pageOptions.length} 
                  </strong>
              </span>
              
              <a >
              <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                      Siguiente
                  </button>
                  
                 
                 
              </a>
              
          </div>:null}

      </>
  )
}